import { useMemo, useState, type PropsWithChildren } from "react";

import { PreferencesContext, type PreferenceState } from "./preferencesContext";

function storedAntiSpoiler() {
  try {
    return localStorage.getItem("localpedia:anti-spoiler:v1") !== "off";
  } catch {
    return true;
  }
}

export function PreferencesProvider({ children }: PropsWithChildren) {
  const [antiSpoiler, updateAntiSpoiler] = useState(storedAntiSpoiler);
  const value = useMemo<PreferenceState>(() => ({
    antiSpoiler,
    setAntiSpoiler(next) {
      updateAntiSpoiler(next);
      try { localStorage.setItem("localpedia:anti-spoiler:v1", next ? "on" : "off"); } catch { /* optional preference storage */ }
    },
  }), [antiSpoiler]);
  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
}
